import React, { useState } from 'react';
import { PortfolioProvider, usePortfolioContext } from '../../components/Portfolio/PortfolioContext';
import PortfolioGroupList from '../../components/Portfolio/PortfolioGroupList';
import PortfolioGroupForm from '../../components/Portfolio/PortfolioGroupForm';
import PortfolioHeader from '../../components/Portfolio/PortfolioHeader';
import PortfolioTabs from '../../components/Portfolio/PortfolioTabs';

export default function Portfolio() {
    return (
        <PortfolioProvider>
            <PortfolioContent />
        </PortfolioProvider>
    );
}

function PortfolioContent() {
    const { selectedGroup, loading, groups, refreshGroups } = usePortfolioContext();
    const [showCreateForm, setShowCreateForm] = useState(false);

    return (
        <div className="flex flex-col h-full bg-slate-50">
            {/* Page Header */}
            <div className="px-8 py-6 border-b border-slate-100 bg-white">
                <div className="flex-1">
                    <h2 className="text-3xl font-black text-slate-900 tracking-tight">
                        Portfolio Groups
                    </h2>
                    <p className="text-sm text-slate-500 mt-2">
                        Manage your portfolio groups and assets · {groups.length} group{groups.length !== 1 ? 's' : ''}
                    </p>
                </div>
            </div>

            {/* Page Body */}
            <div className="flex flex-1 min-h-0">
                {/* Left sidebar: group list */}
                <div className="w-72 min-w-[288px] border-r border-slate-200 bg-white flex flex-col">
                    <PortfolioGroupList onCreateClick={() => setShowCreateForm(true)} />
                </div>

                {/* Right content area */}
                <div className="flex-1 overflow-auto">
                    {loading && !selectedGroup ? (
                        <div className="flex items-center justify-center h-full">
                            <div className="flex flex-col items-center gap-3">
                                <div className="w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                                <span className="text-sm text-slate-500 font-medium">Loading...</span>
                            </div>
                        </div>
                    ) : selectedGroup ? (
                        <div className="flex flex-col h-full">
                            <PortfolioHeader />
                            <div className="flex-1 overflow-auto p-6">
                                <PortfolioTabs />
                            </div>
                        </div>
                    ) : (
                        <div className="flex items-center justify-center h-full text-slate-400">
                            <div className="text-center">
                                <span className="material-symbols-outlined text-[64px] mb-4 block">account_balance_wallet</span>
                                <p className="text-lg font-medium">Select a portfolio group</p>
                                <p className="text-sm mt-1">Or create a new one to get started</p>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showCreateForm && (
                <PortfolioGroupForm
                    onClose={() => setShowCreateForm(false)}
                    onCreated={() => { setShowCreateForm(false); refreshGroups(); }}
                />
            )}
        </div>
    );
}
